import {
  FactTableQuery,
  FactTableQueryVariables,
  FactTableWithWarehouseFragment,
  FactTablesDocument,
  useFactTableQuery,
  useOnFactTableCreatedSubscription,
  useOnFactTableUpdatedSubscription,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

const useFactTableImpl = withStandardGetHook<
  FactTableQuery,
  FactTableWithWarehouseFragment,
  'factTable',
  FactTableQueryVariables
>(useFactTableQuery, 'factTable');

export const useFactTable: typeof useFactTableImpl = options => {
  useOnFactTableCreatedSubscription({
    onData: _options => {
      _options.client.refetchQueries({
        include: [FactTablesDocument],
      });
    },
    skip: options.skip,
  });

  useOnFactTableUpdatedSubscription({
    skip: options.skip,
  });

  return useFactTableImpl(options);
};
